import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import QuoteStatusBadge from "../../../../quote/status.component.jsx";
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import EventBus from "../../../../common/EventBus";
import BookingSection from "./booking.component.jsx";
import LoadingSpinner from "../../../../common/spinner/loading.component.jsx"
import Icon from "../../../../common/icon/icon.component.jsx"
import SectionWrapper from "../../sectionwrapper.component.jsx";
import ProposalMergeFields from "../../../MergeFields.jsx";
import PaymentContentSection from "../payment/section.component.jsx";
import SignatureContentSection from "../signature/section.component.jsx";
import GlobalHelper from "../../../../common/GlobalHelper.jsx";
import { TypeCustomFieldRequiredError, TypeLineItemProductCustomAttributeRequiredError } from "../../../../state/helpers/ErrorTypes"

let commentUpdateDebounceTimer
class ApproveContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        let notes = ''
        if (this.props.variables) {
            notes = this.props.variables.quote.notes
        }
        this.state = {
            section: this.props.section || null,
            variables: this.props.variables || null,
            options: this.props.options || [],
            isPdf: this.props.isPdf || false,
            isSample: this.props.isSample || false,
            isDummy: this.props.isDummy || false,
            editable: this.props.editable === true,
            id: this.props.id || '',
            notes: notes,
            showApprovedMessage: false,
            loading: false,
            missingCheckBox: '',
            approved: false,
            itemQuantities: [],
            signUpUrl: 'https://www.quotemachine.com/sign-up?utm_medium=quote_sample&utm_source=quote',
            selectedChoices: [],
            multipleChoiceOptions: [],
            itemCustomAttributeValues: [],
            itemCustomAttributeError: false,
            customFieldRequiredError: false,

        }
        this.handleOptionsChange = this.handleOptionsChange.bind(this)
        this.preApprove = this.preApprove.bind(this)
        this.preDecline = this.preDecline.bind(this)
        this.handleProposalRefresh = this.handleProposalRefresh.bind(this)
        EventBus.listen(EventBus.TopicPricingTableOptionsSelectedChanged, 'approve-section', this.handleOptionsChange)
        EventBus.listen(EventBus.TopicProposalRefresh, 'approve-section', this.handleProposalRefresh)
    }

    componentWillReceiveProps(nextProps) {
        let notes = ''
        if (nextProps.variables) {
            notes = nextProps.variables.quote.notes
        }
        this.setState({
            notes: notes,
            variables: nextProps.variables || null,
            section: nextProps.section || null,
            isPdf: nextProps.isPdf || false,
            id: nextProps.id || '',
        })
    }


    preApprove(event) {
        event.preventDefault()
        if (this.state.isSample) {
            window.location = this.state.signUpUrl
            return
        }

        if (!this.state.approved) {
            this.setState({
                missingCheckBox: <p className={"m-0 text-secondary"}>
                    <Icon value="arrow-up" className={"mr-2"} />
                    <em>
                        <FormattedMessage
                            id="proposal.missing_checkbox_message"
                            defaultMessage="Check the box to accept."
                        />
                    </em>
                </p>
            })
            return
        }


        this.setState({ loading: true })
        AppContext.getApiClient().setAccountId(this.state.variables.quote.accountId)

        AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/pre-approve', {
            fingerprintId: GlobalHelper.getFingerprintId(),
            chosenOptions: this.state.options,
            selectedChoices: this.state.selectedChoices,
            multipleChoiceOptions: this.state.multipleChoiceOptions,
            itemQuantities: this.state.itemQuantities,
            notes: this.state.notes,
            simulate: false,
        }).then(res => {
            if (!res.error) {
                this.setState({
                    variables: res.attributes.variables,
                    loading: false,
                    itemCustomAttributeError: false,
                }, () => {
                    EventBus.dispatch(EventBus.TopicProposalPreApproved, {
                        variables: this.state.variables
                    })
                })
            } else if (res.error.type === TypeLineItemProductCustomAttributeRequiredError) {
                this.setState({
                    loading: false,
                    itemCustomAttributeError: true,
                })
            }
            else if (res.error.type === TypeCustomFieldRequiredError) {
                this.setState({
                    loading: false,
                    customFieldRequiredError: true,
                })
            }
        })
    }

    preDecline(event) {
        if (this.state.isSample) {
            window.location = this.state.signUpUrl
            return
        }
        if (this.shouldShowComment() && !this.validateCustomerForm()) {
            return
        }
        this.setState({ loading: true })
        event.preventDefault()
        AppContext.getApiClient().setAccountId(this.state.variables.quote.accountId)
        AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/pre-decline', {
            notes: this.state.notes,
            simulate: false,
        }).then(res => {
            this.setState({
                variables: res.attributes.variables,
                loading: false,
            }, () => {
                EventBus.dispatch(EventBus.TopicProposalPreDeclined, {
                    variables: this.state.variables
                })
            })
        })
    }

    validateCustomerForm() {
        let form = document.getElementById("comment-form")
        const checkResult = form.checkValidity()
        form.classList.add('was-validated')
        return checkResult
    }

    handleOptionsChange(event) {
        this.setState({
            itemCustomAttributeValues: event.getData().itemCustomAttributeValues,
            options: event.getData().options,
            selectedChoices: event.getData().selectedChoices,
            multipleChoiceOptions: event.getData().multipleChoiceOptions,
            itemQuantities: event.getData().itemQuantities,
        })
    }

    isApproveFormHidden() {
        return this.state.section.attributes.content.hide
    }

    shouldShowComment() {
        return !this.state.section.attributes.content.hideComment
    }

    handleProposalRefresh(event) {
        if (this.state.variables.quote.status !== event.getData().variables.quote.status) {
            this.setState({
                variables: event.getData().variables,
            })
        }
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }
        let actionBar = ''
        let noteForm = this.state.notes ? <blockquote className="blockquote">
            <p className="mb-0">{this.state.notes.split('\n').map((item, key) => {
                return <span key={key}>{item}<br /></span>
            })}</p>
            <footer className="blockquote-footer">{this.state.variables.customer.name}</footer>
        </blockquote> : ''

        let checkboxContent = <label className="custom-control-label px-2" htmlFor="approveCheckBox">
            <FormattedMessage
                id="proposal.approve_checkbox"
                defaultMessage="Yes, I {name} agree to and accept this quote"
                values={{
                    name: this.state.variables.customer.name
                }}
            />
        </label>

        let checkboxTextOnly = this.state.section.attributes.content.checkBoxText
        if (checkboxTextOnly) {
            checkboxTextOnly = checkboxTextOnly.replace(/<\/?[^>]+(>|$)/g, "").trim()
        }

        if (checkboxTextOnly) {
            checkboxContent = <label className="custom-control-label px-2 rich-text" htmlFor="approveCheckBox">
                <div dangerouslySetInnerHTML={{ __html: ProposalMergeFields.merge(this.state.section.attributes.content.checkBoxText, this.state.variables, this.state.isDummy, this.props.intl) }} />
            </label>
        }
        var isDraftOrDummy = this.state.isDummy || this.state.variables.quote.status == 'draft'
        if ((this.state.variables.quote.isPreApprovable || isDraftOrDummy) && !this.state.isPdf) {
            const disabled = this.state.loading

            actionBar = <div className="approve-btn-container text-left">
                <div className={'row'}>
                    {
                        !this.state.section.attributes.content.hideAcceptButton &&
                        <div className={'col-12 pb-3 pt-1'}>
                            <div className="custom-control custom-checkbox " style={{
                                color: this.state.variables.global.buttonColor,
                                fontSize: '1rem',
                            }}>
                                <input disabled={disabled} type="checkbox" className="custom-control-input" id="approveCheckBox" checked={this.state.approved} onChange={e => {
                                    this.setState({
                                        approved: e.target.checked
                                    })
                                }} />
                                {checkboxContent}
                            </div>
                            {this.state.missingCheckBox}

                        </div>
                    }
                    <div className={'col-12 mb-0'}>
                        {
                            !this.state.section.attributes.content.hideAcceptButton &&
                            <button disabled={disabled || isDraftOrDummy} type="submit" className="btn btn-primary px-5 py-2 approve-btn" style={{
                                outlineColor: this.state.variables.global.buttonColor,
                                backgroundColor: this.state.variables.global.buttonColor,
                                borderColor: this.state.variables.global.buttonColor,
                                fontSize: '1.1rem',
                                fontWeight: 'bold',
                            }} onClick={this.preApprove}>
                                {this.state.section.attributes.content.acceptButtonText ? this.state.section.attributes.content.acceptButtonText : <FormattedMessage
                                    id="proposal.approve_btn"
                                    defaultMessage="Approve"
                                />}
                            </button>
                        }
                        {
                            !this.state.section.attributes.content.hideDeclineButton &&
                            <button type="button" className={`btn approve-btn ${this.state.section.attributes.content.hideAcceptButton ? 'btn-danger' : 'btn-link ml-2'}`} style={{
                                outlineColor: this.state.variables.global.buttonColor,
                                color: this.state.section.attributes.content.hideAcceptButton ? '' : this.state.variables.global.buttonColor,
                                fontSize: '1.1rem',
                                // backgroundColor: 'white',
                                // borderColor: this.state.variables.global.buttonColor,
                            }} disabled={disabled || isDraftOrDummy} onClick={this.preDecline}>
                                {this.state.section.attributes.content.declineButtonText ? this.state.section.attributes.content.declineButtonText : <FormattedMessage
                                    id="proposal.decline_btn"
                                    defaultMessage="Decline"
                                />}
                            </button>
                        }
                        {
                            this.state.itemCustomAttributeError &&
                            <div className="text-danger mb-2 mt-2">
                                <small>
                                    <Icon value={"exclamation"} className={"mr-1"} />
                                    <FormattedMessage
                                        id="proposal.custom_attribute.error_message"
                                        defaultMessage="Please fill all required product attributes to continue"
                                    />
                                </small>
                            </div>
                        }
                        {
                            this.state.customFieldRequiredError &&
                            <div className="text-danger mb-2 mt-2">
                                <small>
                                    <Icon value={"exclamation"} className={"mr-1"} />
                                    <FormattedMessage
                                        id="proposal.custom_field_required.error_message"
                                        defaultMessage="Please fill all required custom form fields to continue"
                                    />
                                </small>
                            </div>
                        }

                    </div>
                </div>

                &nbsp;
                &nbsp;

            </div>



            noteForm = <textarea
                disabled={disabled}
                required
                id="notes"
                name="notes"
                value={this.state.notes}
                onChange={(event) => {
                    this.setState({ notes: event.target.value })
                }}
                onKeyUp={(event) => {
                    clearTimeout(commentUpdateDebounceTimer);
                    commentUpdateDebounceTimer = setTimeout(() => {
                        AppContext.getApiClient().patch('/proposals/' + this.state.variables.hash + '/comment', {
                            notes: event.target.value,
                        }).then(res => { })
                    }, 500);
                }}
                className="form-control rich-content"
                rows="4"
            />

        } else {
            actionBar = <div className="lead w-100">
                <FormattedMessage
                    id="proposal.proposal_status"
                    defaultMessage="Proposal status"
                /> :
                &nbsp;
                <QuoteStatusBadge status={this.state.variables.quote.status} />
            </div>
        }
        if (this.state.loading) {
            actionBar = <LoadingSpinner />
        }

        if (this.isApproveFormHidden() && this.state.editable) {
            return <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={true}
                variables={this.state.variables}
                clickable={true}
            >
                <div className={"col-12"}>
                    <p className={"section-empty-message text-left"}>
                        <Icon value={"check"} />
                        <small className={"ml-2"}>
                            <FormattedMessage
                                id="templates.sections.approve_section.hidden_message"
                                defaultMessage="Approve section hidden (this message won't show on your customer's version)"
                            />
                        </small>
                    </p>
                </div>
                <div className="col-12">
                    <PaymentContentSection
                        included={true}
                        section={this.state.section}
                        variables={this.state.variables}
                        isPdf={this.state.isPdf}
                        editable={false}
                        autoOpen={false}
                    />
                </div>
            </SectionWrapper>
        } else if (this.isApproveFormHidden()) {
            return <div className="col-12">
                <PaymentContentSection
                    included={true}
                    section={this.state.section}
                    variables={this.state.variables}
                    isPdf={this.state.isPdf}
                    editable={false}
                    autoOpen={false}
                />
            </div>
        }

        const showSignature = ["pre-approved", "approved"].includes(this.state.variables.quote.status) &&
            this.state.section.attributes.content.allowSignature

        return <SectionWrapper
            id={this.state.id}
            section={this.state.section}
            onEdit={this.state.onEdit}
            variables={this.state.variables}
            editable={this.state.editable}
        >
            {this.shouldShowComment() &&
                <div className={'col-12 ' + (noteForm ? 'pt-2' : '')}>
                    <form id={'comment-form'}>
                        <div className="row">
                            {(this.state.variables.quote.isPreApprovable || isDraftOrDummy) && !this.state.isPdf ? <label className="col-12 col-form-label custom-form-label pb-2" htmlFor="notes">
                                <FormattedMessage
                                    id="proposal.approve.notes"
                                    defaultMessage="Comments"
                                />
                            </label> : ''}
                            <div className={'col-12 ' + (noteForm ? 'mb-3' : '')}>
                                {noteForm}
                                <div className="invalid-feedback">
                                    <FormattedMessage
                                        id="proposal.approve.comment_form.decline_field_error"
                                        defaultMessage="Please ensure comment is filled out properly"
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            }
            <div className="col-12 text-center">
                {actionBar}
            </div>
            {this.state.variables.quote.items.filter(i => i.needsBooking).length > 0 &&
                ["pre-approved", "approved"].includes(this.state.variables.quote.status) ? <div className="col-12">
                <div className={"row"}>
                    <h5 className={"col-12 text-white border-0 pt-2 pb-2 px-3 d-flex "} style={{
                        backgroundColor: this.state.variables.global.groupTitleBackgroundColor || '#6c757d'
                    }}>
                        <FormattedMessage
                            id="proposal.booking_title"
                            defaultMessage="Booking"
                        />
                    </h5>
                </div>
                <BookingSection
                    variables={this.state.variables}
                    section={this.state.section}
                    isPdf={this.state.isPdf}
                />
            </div> : ''}
            {this.state.variables.postActions.length > 0 &&
                ["pre-approved", "approved"].includes(this.state.variables.quote.status) ? <div className="col-12">
                <div className={"row mx-1 mt-3"}>
                    {this.state.variables.postActions.map(a => {
                        return <div className={'col-12 d-flex align-items-center border-top py-2'}>
                            <div>
                                {a.image ? <img className={"img-rounded mr-3 my-2"} width="75px" src={a.image} /> : ''}
                            </div>
                            <p className="flex-fill px-3 mb-0" style={{
                                fontSize: '1.1rem',
                            }}>
                                {a.description}
                            </p>
                            <div>
                                <a href={a.link} className="btn btn-primary px-2 py-2 approve-btn" style={{
                                    outlineColor: this.state.variables.global.buttonColor,
                                    backgroundColor: this.state.variables.global.buttonColor,
                                    borderColor: this.state.variables.global.buttonColor,
                                    fontSize: '0.9rem',
                                    fontWeight: 'bold',
                                }} target={'_blank'}>
                                    <Icon value={'chevron-right'} className={'mr-1'} />
                                    {a.label}
                                </a>
                            </div>
                        </div>
                    })}
                </div>
            </div> : ''}
            {showSignature ? <div className="col-12 pb-3 border-bottom">
                <SignatureContentSection
                    section={this.state.section}
                    variables={this.state.variables}
                    editable={false}
                    included={true}
                    isPdf={this.state.isPdf}
                />
            </div> : ''}
            {this.state.section.attributes.content.allowDepositPayment && !this.state.loading && <div className="col-12">
                <PaymentContentSection
                    included={true}
                    section={this.state.section}
                    variables={this.state.variables}
                    isPdf={this.state.isPdf}
                    editable={false}
                    autoOpen={true}
                    hideAcceptButton={this.state.section.attributes.content.hideAcceptButton}
                    onVariablesUpdate={newVariables => {
                        this.setState({
                            variables: newVariables,
                        })
                    }}
                />
            </div>}
        </SectionWrapper>

    }

}

export default injectIntl(ApproveContentSection)





// WEBPACK FOOTER //
// ./src/template/sections/content/approve-section/section.component.jsx